import React, { useState } from 'react';
import { Pressable, Text, View, StyleSheet } from 'react-native';
import { useAdminColors } from '@/hooks/admin/useAdminColors';
import { sentimentColor } from './sentimentColor';
import type { SentimentLabel, SentimentQuote } from '@/types/sentiment';

const ORDER: SentimentLabel[] = ['positive', 'neutral', 'negative'];

interface Props {
  quotes: SentimentQuote[];
}

export const QuotesAccordion: React.FC<Props> = ({ quotes }) => {
  const { redesign } = useAdminColors();
  const palette = sentimentColor(redesign);
  const [open, setOpen] = useState<Record<SentimentLabel, boolean>>({
    positive: false,
    neutral: false,
    negative: false,
  });
  const bySent = (s: SentimentLabel) => quotes.filter(q => q.sentiment === s);

  return (
    <View>
      {ORDER.map(s => {
        const items = bySent(s);
        const isOpen = open[s];
        return (
          <View key={s} style={styles.section}>
            <Pressable
              testID={`accordion-header-${s}`}
              onPress={() => setOpen({ ...open, [s]: !isOpen })}
              style={styles.headerRow}
              accessibilityRole="button"
              accessibilityState={{ expanded: isOpen }}
            >
              {/* Disclosure caret so it's obvious the row expands. */}
              <Text style={[styles.caret, { color: redesign.text.secondary }]}>
                {isOpen ? '▾' : '▸'}
              </Text>
              <Text style={[styles.header, { color: palette[s] }]}>
                {s.toUpperCase()} ({items.length})
              </Text>
            </Pressable>
            {isOpen &&
              items.map(q => (
                <Text
                  key={q.answerId}
                  style={[styles.quote, { color: redesign.text.secondary }]}
                >
                  "{q.text}"
                </Text>
              ))}
          </View>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  section: { marginTop: 8 },
  headerRow: { flexDirection: 'row', alignItems: 'center', gap: 6 },
  caret: { fontSize: 11, width: 12 },
  header: { fontWeight: '700', fontSize: 12 },
  quote: { marginLeft: 18, marginTop: 4, fontStyle: 'italic' },
});
